<ion-content>
<ion-router-outlet></ion-router-outlet>
</ion-content>
